/** Open a NEXUS report document payload (lite / exec summary / modular PDF). */

import { openReportLoadingTab } from "../utils/reportPdfLoader";
import {
  fetchExecutiveSummaryStatus,
  generateExecutiveSummaryPdf,
  openLiteCompanyReportPdf,
  openModularReportPdf,
} from "../api/reportProfilesClient";

/**
 * @param {{ kind?: string, company_name?: string, role?: string, profile_id?: string, label?: string }} reportDoc
 * @returns {Promise<{ openedInTab?: boolean, downloaded?: boolean }>}
 */
export async function openReportDocument(reportDoc) {
  const { kind, company_name, role, profile_id } = reportDoc || {};
  if (!company_name) {
    throw new Error("Company name is required to open a report");
  }
  if (kind === "lite") {
    return openLiteCompanyReportPdf(company_name);
  }
  if (kind === "executive_summary") {
    const statusRes = await fetchExecutiveSummaryStatus(company_name);
    if (!statusRes?.data?.ready) {
      throw new Error(
        "No completed surveys yet — executive summaries are unavailable until the team finishes the assessment."
      );
    }
    const win = openReportLoadingTab("Generating executive summary…");
    const blob = await generateExecutiveSummaryPdf(company_name, role || "CEO");
    const url = URL.createObjectURL(blob);
    if (win) {
      win.location.href = url;
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
      return { openedInTab: true, downloaded: false };
    }
    const a = window.document.createElement("a");
    a.href = url;
    a.download = `${company_name.replace(/\s+/g, "_")}_Executive_Summary.pdf`;
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return { openedInTab: false, downloaded: true };
  }
  return openModularReportPdf(
    company_name,
    profile_id || (kind === "company" ? "company_analyzed" : "team_analyzed"),
    role || ""
  );
}
